module.exports = __webpack_public_path__ + "header-profile-skin-3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/styles/patterns/header-profile-skin-3.png
// module id = 884
// module chunks = 11